import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import GoogleGLogo from '../icons/googleGLogo';

/* =====================================================================
   GoogleLoginButton
   ---------------------------------------------------------------------
   The `useGoogleLogin` hook MUST live in a component that is only
   RENDERED when the tenant actually has a GOOGLE_CLIENT_ID.

   Why: the hook initialises Google's token client, which throws
   "Missing required parameter client_id" when the id is empty
   (App.js passes `settings?.GOOGLE_CLIENT_ID ?? ''`). Hooks cannot be
   called conditionally, so the call sites' existing
   `{settings?.GOOGLE_CLIENT_ID && <button .../>}` guard hid the BUTTON
   but not the HOOK — it still ran and crashed the whole page through the
   error boundary. For a guest at checkout that meant the checkout form
   never rendered at all.

   Keeping the hook here means an unset client id simply renders nothing.
   ===================================================================== */

const GOOGLE_SCOPE =
  'openid https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile';

const GoogleLoginButton = ({ onSuccess, onError, label }) => {

  const customGoogleLogin = useGoogleLogin({
    onSuccess,
    onError,
    scope: GOOGLE_SCOPE
  });

  return (
    <button
      className="my-google-button-class"
      onClick={() => customGoogleLogin()}
      aria-labelledby='google login'
    >
      <GoogleGLogo/><span>{label}</span>
    </button>
  );
};

export default GoogleLoginButton;
